import { render, staticRenderFns } from "./PrivacyAgree.vue?vue&type=template&id=7963e8dd&scoped=true&"
import script from "./PrivacyAgree.vue?vue&type=script&lang=js&"
export * from "./PrivacyAgree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963e8dd",
  null
  
)

export default component.exports